import {
    DELETE_PRODUCT_MEMBERSHIP_SUCCESS,
    FETCH_PRODUCT_MEMBERSHIP,
    FETCH_PRODUCT_MEMBERSHIP_FAILURE,
    FETCH_PRODUCT_MEMBERSHIP_SUCCESS,
    FETCH_PRODUCT_MEMBERSHIPS,
    FETCH_PRODUCT_MEMBERSHIPS_FAILURE,
    FETCH_PRODUCT_MEMBERSHIPS_SUCCESS,
    PRODUCT_MEMBERSHIPS_LIST_FILTER_CATEGORY,
    PRODUCT_MEMBERSHIPS_LIST_FILTER_UPDATE,
    PRODUCT_MEMBERSHIPS_LIST_PAGE,
    PRODUCT_MEMBERSHIPS_LIST_SORT,
    SORT_DESC,
    UPDATE_PRODUCT_MEMBERSHIP_SUCCESS,
} from 'store/actions/types';

import paginationHelper from 'helpers/pagination';
import reducerHelper from 'helpers/reducers';
import utils from 'helpers/utils';

const initialState = {
    data: {},
    field: 'name',
    filter: {},
    filterCategory: reducerHelper.FILTER_BASIC,
    ids: [],
    loading: false,
    offset: 0,
    order: SORT_DESC,
    page: 1,
    size: 24,
    total: 0,
};

export default function (state = initialState, action) {
    switch (action.type) {
        case FETCH_PRODUCT_MEMBERSHIP:
        case FETCH_PRODUCT_MEMBERSHIPS:
            return Object.assign({}, state, {
                loading: true,
            });

        case FETCH_PRODUCT_MEMBERSHIP_FAILURE:
        case FETCH_PRODUCT_MEMBERSHIPS_FAILURE:
            return Object.assign({}, state, {
                loading: false,
            });

        case FETCH_PRODUCT_MEMBERSHIP_SUCCESS:
            return Object.assign({}, state, {
                data: Object.assign({}, state.data, {
                    [action.response.id]: action.response,
                }),
                ids: [
                    ...state.ids,
                    ...action.response.id,
                ],
                loading: false,
            });

        case FETCH_PRODUCT_MEMBERSHIPS_SUCCESS:
            // Converts the Array of results to an Object based on the id.
            const convertResultsToData = utils.mapToObject(action.response.results, (value) => {
                return value.id;
            });

            const newIds = action.response.results.map(function (result) {
                return result.id;
            });

            return Object.assign({}, state, {
                data: Object.assign({}, state.data, convertResultsToData),
                ids: newIds,
                loading: false,
                offset: action.response.offset,
                size: action.response.size,
                total: parseInt(action.response.total, 10),
            });
        case DELETE_PRODUCT_MEMBERSHIP_SUCCESS:
            const {
                id,
            } = action.payload;

            const deletedData = reducerHelper.removeItemFromObject(state.data, id);
            const deletedStateIds = reducerHelper.removeItemFromArrayOfStrings(state.ids, id);

            return Object.assign({}, state, {
                data: deletedData,
                ids: deletedStateIds,
                loading: false,
                total: state.total - 1,
            });

        case UPDATE_PRODUCT_MEMBERSHIP_SUCCESS:
            return {
                ...state,
                loading: false,
                data: {
                    ...state.data,
                    [action.response.id]: action.response,
                },
            };

        case PRODUCT_MEMBERSHIPS_LIST_PAGE:
            return {
                ...state,
                offset: paginationHelper.generateNewOffset(action.payload.page, state.size),
                page: action.payload.page,
            };
        case PRODUCT_MEMBERSHIPS_LIST_SORT:
            return {
                ...state,
                field: action.payload.field,
                order: action.payload.order,
            };
        case PRODUCT_MEMBERSHIPS_LIST_FILTER_CATEGORY:
            return {
                ...state,
                filterCategory: action.payload,
            };
        case PRODUCT_MEMBERSHIPS_LIST_FILTER_UPDATE:
            return {
                ...state,
                ...reducerHelper.normaliseState(initialState, action.payload),
            };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/store/reducers/productMembershipsReducer.js